import React from 'react'
import {Breadcrumb} from 'antd'
import {Link} from "react-router-dom"
export default function BreadcrumbComponent() {
    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Prospects</Breadcrumb.Item>
            </Breadcrumb>
            
        </>
    )
}
